























import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { iconsMixin } from '@/components/ui/UiIcons/iconsPropsMixin'

interface Data {
  localCount: number
  currentPosition: number
  chunkCount: number
}

interface Methods {
  returnChunk: () => void
  nextChunk: () => void
  prevChunk: () => void
}

interface Computed {
  currentChunk: number
}

interface Props {
  items: any[]
  countInChunk: number
  startChunk: number
  usesPagination: boolean
}

export default Vue.extend({
  name: 'SlideList',
  mixins: [iconsMixin],
  props: {
    items: {
      type: Array,
      default: () => []
    },
    countInChunk: {
      type: Number,
      default: () => 1
    },
    startChunk: {
      type: Number,
      default: () => 0
    },
    usesPagination: {
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      localCount: this.countInChunk,
      currentPosition: this.startChunk * this.countInChunk,
      chunkCount: Math.ceil(this.items.length / this.countInChunk)
    }
  },
  computed: {
    currentChunk () {
      return Math.floor(this.currentPosition / this.countInChunk) + 1
    }
  },
  watch: {
    countInChunk (val: number) {
      this.localCount = val
      this.chunkCount = Math.ceil(this.items.length / val)
    },
    currentPosition () {
      this.returnChunk()
    },
    items: {
      handler (value) {
        if (this.currentPosition === value.length && this.currentPosition !== 0) {
          this.currentPosition -= this.countInChunk
        }
        this.returnChunk()
        this.chunkCount = Math.ceil(value.length / this.countInChunk)
      },
      immediate: true
    }
  },
  methods: {
    nextChunk () {
      if (this.currentPosition + this.countInChunk < this.items.length) {
        this.currentPosition += this.localCount
      }
    },
    prevChunk () {
      if (this.currentPosition > 0) {
        this.currentPosition -= this.localCount
      }
    },
    returnChunk () {
      this.$emit('changeChunk',
        this.items.slice(this.currentPosition, this.currentPosition + this.countInChunk)
      )
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
